'use client';

import { type JSX } from 'react';

import AddressInfo from '@/components/registration/CompanyInfoPage/CompanyInfo/AddressInfo';
import BusinessInfo from '@/components/registration/CompanyInfoPage/CompanyInfo/BusinessInfo';
import CompanyBasicInfo from '@/components/registration/CompanyInfoPage/CompanyInfo/CompanyBasicInfo';

interface CompanyInfoProps {
  formData: {
    companyName: string;
    registrationNumber: string;
    foundingDate: string;
    companyType: string;
    taxNumber: string;
    industry: string;
    numEmployees: string;
    annualRevenue: string;
    businessDescription: string;
    registeredCapital: string;
    streetAddress: string;
    city: string;
    state: string;
    postalCode: string;
    country: string;
    [key: string]: string | boolean;
  };
  onChange: (section: string, field: string, value: string | boolean) => void;
}

export default function CompanyInfoPage({
  formData,
  onChange,
}: Readonly<CompanyInfoProps>): JSX.Element {
  return (
    <div className="space-y-8">
      <div className="space-y-10">
        <CompanyBasicInfo formData={formData} onChange={onChange} />
        <BusinessInfo formData={formData} onChangeAction={onChange} />
        <AddressInfo formData={formData} onChange={onChange} />
      </div>
    </div>
  );
}
